var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';
import iconTypes from './StepIconTypes';
var buildStyle = function (_a, _b) {
    var backgroundColor = _a.backgroundColor, font = _a.font, size = _a.size;
    var readingDirection = _b.readingDirection;
    return {
        main: {
            base: {
                width: 176,
                textAlign: 'center',
                height: '100%',
                padding: '24px 0',
                border: 'none',
                background: 'transparent',
                color: font.color.base,
                fontFamily: font.base.family
            }
        },
        stepName: __assign({ base: {
                margin: 0,
                padding: '8px 8px 0 8px',
                fontSize: font.base.size.m,
                fontWeight: font.base.weight.regular,
                pointerEvents: 'none',
                color: font.color.soft
            }, withSubHeading: {
                marginBottom: 0
            }, error: {
                color: font.color.danger.base
            }, current: {
                color: font.color.base
            }, completed: {
                color: font.color.soft
            }, incomplete: {
                color: font.color.soft
            }, processing: {
                color: font.color.base
            }, hover: {
                color: font.color.hover
            } }, readingDirection),
        progressBarContainer: {
            base: {
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontFamily: font.base.family
            },
            withSubHeading: {
                marginTop: 2
            }
        },
        progressBar: {
            base: {
                backgroundColor: backgroundColor.interactive.active,
                height: 2,
                width: 72
            },
            left: {
                marginRight: 4
            },
            right: {
                marginLeft: 4
            },
            leftRtl: {
                marginLeft: 4
            },
            rightRtl: {
                marginRight: 4
            },
            end: {
                backgroundColor: 'transparent'
            },
            active: {
                backgroundColor: backgroundColor.accent.fill.base
            },
            completed: {
                backgroundColor: backgroundColor.accent.fill.base
            }
        },
        stepStatus: {
            base: {
                height: 24,
                width: 24,
                borderRadius: size.border.radius.round,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: font.base.size.s,
                fontFamily: font.base.family
            }
        },
        subHeadingWrapper: {
            base: {
                fontSize: font.base.size.xs,
                color: font.color.soft
            }
        }
    };
};
var useStyle = function (_a) {
    var isRtl = _a.isRtl, isCurrentStep = _a.isCurrentStep, status = _a.status, hover = _a.hover, isFirst = _a.isFirst, isLast = _a.isLast, subHeading = _a.subHeading;
    var builtStyle = useBuildStyleWithTheme(buildStyle, { isRtl: isRtl });
    if (!builtStyle) {
        return {
            main: {},
            stepName: {},
            progressBarContainer: {},
            progressBarLeft: {},
            progressBarRight: {},
            stepStatus: {},
            subHeadingWrapper: {}
        };
    }
    var main = builtStyle.main, stepName = builtStyle.stepName, progressBarContainer = builtStyle.progressBarContainer, progressBar = builtStyle.progressBar, stepStatus = builtStyle.stepStatus, subHeadingWrapper = builtStyle.subHeadingWrapper;
    return {
        main: __assign({}, main.base),
        stepName: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, stepName.base), (subHeading && stepName.withSubHeading)), (status === iconTypes.completed && stepName.completed)), (status === iconTypes.active && stepName.current)), (status === iconTypes.error && stepName.error)), (status === iconTypes.incomplete && stepName.incomplete)), (status === iconTypes.processing && stepName.processing)), (status === iconTypes.error && isCurrentStep && stepName.current)), (hover && stepName.hover)),
        progressBarContainer: __assign(__assign({}, progressBarContainer.base), (subHeading && progressBarContainer.withSubHeading)),
        progressBarLeft: __assign(__assign(__assign(__assign(__assign(__assign({}, progressBar.base), (!isRtl && progressBar.left)), (status === iconTypes.completed && progressBar.completed)), (status === iconTypes.active && progressBar.active)), (isFirst && progressBar.end)), (isRtl && progressBar.leftRtl)),
        progressBarRight: __assign(__assign(__assign(__assign(__assign(__assign({}, progressBar.base), (!isRtl && progressBar.right)), (status === iconTypes.completed && progressBar.completed)), (status === iconTypes.active && progressBar.active)), (isLast && progressBar.end)), (isRtl && progressBar.rightRtl)),
        stepStatus: __assign({}, stepStatus.base),
        subHeadingWrapper: __assign({}, subHeadingWrapper.base)
    };
};
export default useStyle;
